import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { arrayMove, SortableContainer, SortableElement } from "react-sortable-hoc";
import { apiURL } from "../../../../config/default";
import axios from "axios";

let checkBoxCancelToken;

const SortFilters = ({ includedData }) => {
  const [included, setIncluded] = useState({
    ids: [],
    categoryId: "",
    filterOptions: [],
  });
  useEffect(() => {
    if (includedData) {
      setIncluded({
        ids: includedData.ids,
        categoryId: includedData.categoryId,
        filterOptions: includedData.filterOptions,
      });
    }
  }, [includedData]);

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     setloading(true);
  //     try {
  //       const res = await dispatch(
  //         ticketNotesUpdate(SelectItem._id, {
  //           note: {
  //             subject: formData.subject,
  //             message: formData.message,
  //             read: false,
  //           },
  //         })
  //       );

  //       if (res) {
  //         console.log("response data is : ", res?.data);
  //         setloading(false);
  //         setEdit({
  //           open: false,
  //           edit: "",
  //           title: "",
  //         });
  //         setData((prevData) => {
  //           const updatedData = prevData.map((item) => {
  //             if (item?._id === res?.ticket?._id) {
  //               return res?.ticket;
  //             }
  //             return item;
  //           });
  //           return updatedData;
  //         });
  //       }
  //     } catch (error) {
  //       setloading(false);
  //     }
  //   };
  const SortableItem = SortableElement(({ item }) => (
    <div className="__item" style={{ padding: "4px", margin: '2px', backgroundColor: '#000', color: '#fff', cursor: 'all-scroll' }}>
      <div className="__inner-item">
        <p>{item.title}</p>
      </div>
    </div>
  ));

  const SortableList = SortableContainer(({ items }) => (
    <div className="__container">
      {items.map((item, index) => (
        <SortableItem key={`${item._id}`} index={index} item={item} />
      ))}
    </div>
  ));
  const onSortEnd = async ({ oldIndex, newIndex }) => {
    const data = {
      ...included,
      ids: arrayMove(included.ids, oldIndex, newIndex),
      filterOptions: arrayMove(included.filterOptions, oldIndex, newIndex),
    };
    setIncluded(data);
    if (typeof checkBoxCancelToken != typeof undefined) {
      checkBoxCancelToken.cancel("Operation canceled due to new request.");
    }
    checkBoxCancelToken = axios.CancelToken.source();
    const dataToSend = { ...data };
    delete dataToSend.filterOptions;
    const _config = {
      cancelToken: checkBoxCancelToken.token,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      await axios.post(
        `${apiURL}filters/include`,
        dataToSend,
        _config
      );
    } catch (err) {
      // const errors = err.response.data.error;
    }
  };
  return (
    <div className="px-3">

      <SortableList
        items={included.filterOptions}
        onSortEnd={onSortEnd}
        axis="xy"
        helperClass="__SortableHelper"
      />
    </div>
  );
};

export default SortFilters;
